import { retry } from '@lifeomic/attempt';
import * as v from 'valibot';
import { config } from '../../../config.js';
import { handleRPCResponse } from '../../../utils/handleRPCResponse.js';
import { request } from '../../../utils/request.js';
import { requestShouldRetry } from '../../../utils/requestShouldRetry.js';

const rpcResponseSchema = v.union([
    // success
    v.object({
        jsonrpc: v.literal("2.0"),
        id: v.string(),
        result: v.unknown(),
    }),
    // error
    v.object({
        jsonrpc: v.literal("2.0"),
        id: v.string(),
        error: v.pipe(v.object({
            code: v.number(),
            message: v.string(),
        }), v.transform((v) => {
            return {
                code: v.code,
                data: null,
                message: v.message,
            };
        })),
    }),
]);
async function jsonRPCRequest(method, params, config$1) {
    const url = `${config.env.solverRelayBaseURL}/rpc`;
    const body = {
        id: config$1?.requestId ?? "dontcare",
        jsonrpc: "2.0",
        method,
        params: params !== undefined ? [params] : undefined,
    };
    const response = await retry(() => {
        return request({
            url,
            body,
            ...config$1,
            fetchOptions: {
                ...config$1?.fetchOptions,
                method: "POST",
            },
        });
    }, {
        delay: 200,
        maxAttempts: 3,
        handleError: (err, context) => {
            if (!requestShouldRetry(err)) {
                context.abort;
            }
        },
    });
    return handleRPCResponse(response, body, rpcResponseSchema);
}

export { jsonRPCRequest };
//# sourceMappingURL=runtime.js.map
